module.exports = __webpack_public_path__ + "img/Outubro_Rosa_630x400.71ad3618.jpg";